import SendingIcon from 'src/assets/icons/fi-rr-envelope.svg';
import { FieldMappingsMockUpType } from '../types';

export const selectedData = {
  value: '',
  to_crm_if_blank: false,
  from_sprouts: true,
  nosync: false,
  // crm to sproutes
  toSprouts: true,
  dontSyncToSprouts: false,
};

export const EmailFieldMappings: FieldMappingsMockUpType = {
 id: 'email',
  label: 'Emails',
  testRunId: 'sendings',
  testRunLabel: 'Sendings',
  icon: SendingIcon,
  desc: 'Fields mapped',
  count: '0',
  entity: 'Mailings',
  sproutsFields: [
    {
      label: 'Email Subject',
      id: 'subject',
      selectedData,
      activityType: 'Emails',
      onlyOutbound: false,
      disableToCrmIfBlank: true,
      required: true,
    },
    {
      label: 'Email Body',
      id: 'body',
      selectedData,
      activityType: 'Emails',
      onlyOutbound: false,
      disableToCrmIfBlank: true,
      required: true,
    },
    {
      label: 'Status',
      id: 'state',
      selectedData,
      activityType: 'Emails',
      onlyOutbound: false,
      supportedTypes: ['Object','String'],
      disableToCrmIfBlank: true,
      required: true,
    },
    {
      label: 'Sender’s Name',
      id: 'ownerName',
      selectedData,
      activityType: 'Emails',
      onlyOutbound: false,
      disableToCrmIfBlank: true,
    },
    {
      label: 'Sequence Name',
      id: 'sequenceName',
      selectedData,
      activityType: 'Emails',
      onlyOutbound: true,
      disableToCrmIfBlank: true,
    },
    {
      label: 'Step Number',
      id: 'stepNumber',
      selectedData,
      activityType: 'Emails',
      onlyOutbound: true,
      disableToCrmIfBlank: true,
    },
    {
      label: 'Sprouts thread ID',
      id: 'threadId',
      selectedData,
      activityType: 'Emails',
      onlyOutbound: true,
      disableToCrmIfBlank: true,
      required: true,
    },
    {
      label: 'Is Incoming',
      id: 'isIncoming',
      selectedData,
      activityType: 'Emails',
      onlyOutbound: false,
      disableToCrmIfBlank: true,
      required: true,
    },
    {
      label: 'Activity time',
      id: 'dateUtc',
      selectedData,
      activityType: 'Emails',
      onlyOutbound: false,
      disableToCrmIfBlank: true,
    },

    // for  send email as task
        // { 
        //   label: 'Task Type',
        //   id: 'type',
        //   selectedData,
        //   onlyOutbound: false,
        //   disableToCrmIfBlank: true,
        //   activityType: 'Tasks',
        // },
        // {
        //   label: 'Task SubType',
        //   id: 'threadType',
        //   selectedData,
        //   onlyOutbound: false,
        //   disableToCrmIfBlank: true,
        //   required: true,
        //   activityType: 'Tasks',
        // },
  ],
 
};

